import { Fragment, ReactNode } from "react";
import { IntlProvider, IntlShape, createIntl, useIntl } from "react-intl";
import mesgs from "./messages";

export const LOCALES: {
  EN: "EN";
  RU: "RU";
} = {
  EN: "EN",
  RU: "RU",
};

interface ProviderIntlI {
  children: ReactNode;
  locale?: keyof typeof LOCALES;
}

const ProviderIntl = ({ children, locale = LOCALES.EN }: ProviderIntlI) => {
  return (
    <IntlProvider
      messages={mesgs[locale]}
      textComponent={Fragment}
      locale={locale}
      defaultLocale={LOCALES.EN}
    >
      {children}
    </IntlProvider>
  );
};


let globalIntl: IntlShape | undefined = undefined;
export const GlobalIntl = () => {
  globalIntl = useIntl();
  return <></>;
}

export const getGlobalIntl = () => globalIntl ?? createIntl({locale: LOCALES.EN, messages: mesgs[LOCALES.EN]});

export default ProviderIntl;
